import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
  Box,
  Avatar,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import GroupIcon from "@mui/icons-material/Group";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import { ChannelDto } from "../../../types/channel";

const SlideTransition = React.forwardRef(function SlideTransition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ChannelJoinDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  channel: ChannelDto | null;
  isPublic: boolean;
}

export function ChannelJoinDialog({
  open,
  onClose,
  onConfirm,
  channel,
  isPublic,
}: ChannelJoinDialogProps) {
  const title = isPublic
    ? "Unirse al canal público"
    : "Solicitar acceso al canal público con invitación";
  const message = isPublic
    ? `¿Quieres unirte al canal público #${channel?.name}?`
    : `¿Deseas enviar una solicitud para unirte al canal #${channel?.name}?`;
  const confirmLabel = isPublic ? "Unirme" : "Enviar solicitud";

  const icon = isPublic ? (
    <GroupIcon fontSize="large" sx={{ color: "green" }} />
  ) : (
    <LockPersonIcon fontSize="large" sx={{ color: "primary.main" }} />
  );

  const selectedChannel = channel && channel;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={SlideTransition}
      keepMounted
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {icon}
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Avatar
            src={selectedChannel?.imageUrl || "/assets/images/placeholder.svg"}
            alt={selectedChannel?.name}
            sx={{ width: 48, height: 48 }}
            variant="rounded"
          />
          <Typography variant="h6" fontWeight={600}>
            #{selectedChannel?.name}
          </Typography>
        </Box>
        <Typography color="text.secondary">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            bgcolor: isPublic ? "green" : "primary.main",
            "&:hover": {
              bgcolor: isPublic ? "#006400" : "primary.dark",
            },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
